import React, { useState, useEffect } from 'react';
import { Box, Modal,Typography,TextField } from '@material-ui/core';
import Button from "@material-ui/core/Button";
import { Form } from 'reactstrap';
import axios from 'axios';
import moment from 'moment';
import SaveIcon from "@material-ui/icons/Save";
import Paper from '@material-ui/core/Paper';
import swal from 'sweetalert';
import Select from '@material-ui/core/Select';
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { styled } from '@material-ui/core/styles';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 600,
  width: 1000,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderColor: "primary.light",
  background:"#FFB0CF",
  boxShadow: 24,
  p: 3,
};

const InspStyle = {
  position: 'absolute',
  top:'42%',
  left:'73%',
  bgcolor: 'background.paper',
  //border: '1px solid #000',
  borderColor: "primary.light",
  //background:"#FFB0CF",
  marginTop:2,
  //marginLeft: 10,
  height:102,
  width:250
};

const InspBtnStyle = {
  position: 'absolute',
  top:'10%',
  left:'65%',
  //bgcolor: 'background.paper',
  //border: '1px solid red',
  borderColor: "primary.light",
  // marginTop:-10,
  //marginLeft: 10,
  height:80,
  width:80
};
//select 스크롤메뉴높이설정
const selectMenu작업공정Styles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  menuPaper: {
    maxHeight: 520
  }
}));
//select 스크롤메뉴높이설정
const selectMenu보관위치Styles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  menuPaper: {
    maxHeight: 250
  }
}));
const CssTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    color: 'green'
  },
  "& .MuiInputBase-input": {
    WebkitTextFillColor: "green",
  },
  '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },   
    '&:hover fieldset': {
      borderColor: 'blue',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
});
//디세이블 설정부분
const DisabledTextField = styled(TextField)({
  //디세이블시 폰트색상
  "& .MuiInputLabel-root": {
    color: 'green'
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "green",
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },   
    '&:hover fieldset': {
      borderColor: 'red',
    },
    '&.Mui-disabled fieldset': {
      borderColor: 'red',
    },
  },
});
const CssFormControl = styled(FormControl)({
  "& .MuiInputLabel-root": {
    color: 'green'
  },
  "& .MuiInputBase-input": {
    WebkitTextFillColor: "green",
  },
  '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },   
    '&:hover fieldset': {
      borderColor: 'blue',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
});
const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#59b9ea'
   },
  "& .MuiInputBase-input": {
    WebkitTextFillColor: "green",
    color: "red",
  },
  
});
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginTop: theme.spacing(1.2),
    //marginLeft: theme.spacing(0.3),
    // marginRight: theme.spacing(1),
    width: 210,
  },
}));

function IpgoDelete(props) {

  let [orderno, setOrderno] = useState(props.editValue.ipgo_item_auto); //작지번호
  let [belmeng, setBelmeng] = useState(props.editValue.ipgo_item_bel_meng); //별명
  let [worksangtae, setWorksangtae] = useState(props.editValue.ipgo_item_yn); //작업상태
  let [sabun, setSabun] = useState(props.editValue.ipgo_item); //우리품번
  let [cusitem, setCusitem] = useState(props.editValue.ipgo_item_upche_item); //업체품번
  let [cusname, setCusname] = useState(props.editValue.ipgo_item_upche_name); //품명
  let [sangho, setSangho] = useState(props.editValue.ipgo_item_upche_sangho); //업체상호
  let [sanghocode, setSanghocode] = useState(props.editValue.ipgo_upche_code); //업체코드
  let [workcheri, setWorkcheri] = useState(props.editValue.ipgo_item_cheri_desc); //시작공정
  let [chericode, setChericode] = useState(props.editValue.ipgo_item_cheri_code); //종료공정코드
  let [workcherilinecode, setWorkcherilinecode] = useState(props.editValue.ipgo_item_work_cheri_line); //작업라인
  let [workprocesscode, setWorkprocesscode] = useState(props.editValue.ipgo_최종공정라인); //작업공정순서
  let [factory, setFactory] = useState(props.editValue.ipgo_factory); //공장구분(세금계산서 발행기준)
  let [itemmove, setItemmove] = useState(props.editValue.ipgo_ipgojangso); //공정이동처리방법[입고가 1공장인지 2공장인지 구분]
  let [sumdanga, setSumdanga] = useState(props.editValue.ipgo_item_danga);  //합계단가
  let [pimacdanga, setPimacdanga] = useState(props.editValue.ipgo_item_danga_pimac); //피막단가
  let [dopodanga, setDopodanga] = useState(props.editValue.ipgo_item_danga_dopo);   //도포단가
  let [pricesangtae, setPricesangtae] = useState(props.editValue.ipgo_item_price_sangtae); //단가상태
  let [gressweight, setGressweight] = useState(props.editValue.ipgo_gress_weight); //개당중량
  let [boxeach, setBoxeach] = useState(props.editValue.ipgo_dangrang); //당량
  let [pimacdaewi, setPimacdaewi] = useState(props.editValue.ipgo_item_daewi); //파막단위
  let [dopodaewi, setDopodaewi] = useState(props.editValue.ipgo_item_do_danwie);  //도포단위
  let [ipgoquantity, setIpgoquantity] = useState(props.editValue.ipgo_item_quantity);  //입고수량
  let [ipgogumack, setIpgogumack] = useState(props.editValue.ipgo_item_quantity * props.editValue.ipgo_item_danga);  //입고금액(피막+도포)
  let [ipgopimacgumack, setIpgopimacgumack] = useState(props.editValue.ipgo_item_quantity * props.editValue.ipgo_item_danga_pimac);  //입고피막금액
  let [ipgodopogumack, setIpgodopogumack] = useState(props.editValue.ipgo_item_quantity * props.editValue.ipgo_item_danga_dopo);  //입고도포금액
  let [ipgoupchejunpupqty, setIpgoupchejunpupqty] = useState(props.editValue.ipgo_ticket_jundal); //업체전표입고수량
  let [ipgoupchelotcode, setIpgoupchelotcode] = useState(props.editValue.ipgo_upche_lot_code); //업체전표입고로트번호
  let [ipgoboxqty, setIpgoboxqty] = useState(props.editValue.ipgo_ticket_jundal); //입고시업체박스수
  let [changgowichei, setChanggowichei] = useState(props.editValue.ipgo_wi_chi); //창고위치
  let [ipgoticketjundal, setIpgoticketjundal] = useState(props.editValue.ipgo_item_description); //입고전달사항
  let [ipgoyoochengil, setIpgoyoochengil] = useState(); //업체입고요청일자
  let [ipgodatetime, setIpgodatetime] = useState(moment(props.editValue.ipgo_item_datetime).format('YYYY-MM-DD HH:mm')); //입고등록일자
  let [panjung, setPanjung] = useState(props.editValue.ipgo_item_qc_inspection); //합부판정
  let [gumsaja, setGumsaja] = useState(props.editValue.ipgo_item_qc_gumsuja); //입고검사자

  let [changgowicheiopen, setChanggowicheiopen] = useState([]); //창고위치 axios 스테이터
  let [workcherilineopne, setWorkcherilineopne] = useState([]); //작업라인 컨트롤러 쿼리담기
  let [workprocessopen, setWorkprocessopen] = useState([]); //작업공정순서 컨트롤러 궈리담기
  let [gumsajaopen, setGumsajaopen] = useState([]); //입고검사자컨트롤러 궈리담기
  //let [radiogroup, setRadiogroup] = useState('customeritem'); // 찾기 라디오버튼
  //let [sercheoption, setSercheoption] = useState();   //찾기 옵션선택 엔트키
  //let [dataItem, setDataItem] = useState([]);
  //let [dbClickValue, setDbClickValue] = useState([]);
  //let [copen, setCopen] = useState(false); //우리품번/품번찾기 모달
  let [setCustomergumsaopen] = useState(false); //검사항목찾기 모달

  let selectMenu작업공정Classes = selectMenu작업공정Styles(); //select메뉴 스크롤높이설정 변수
  let selectMenu보관위치Classes = selectMenu보관위치Styles(); //select메뉴 스크롤높이설정 변수
  const classes = useStyles();

  //작업라인가져오기
  const getJsonLoadWorkOpen = async () => {
    await axios.get("/IpgoReact/IndexWorkLine")
      .then((res) => {setWorkcherilineopne(res.data)
        })
    };
    
  //작업공정순서가져오기
  const getJsonLoadWorkProcess = async () => {
    await axios.get("/IpgoReact/IndexWorkProcess")
      .then((res) => {setWorkprocessopen(res.data)
        })
    };
  //입고검사자가져오기
  const getJsonLoadGumSaja = async () => {
    await axios.get("/IpgoReact/IndexWorkGumSaja")
      .then((res) => {setGumsajaopen(res.data)
        })
      };
   //창고지정위치 가져오기
   const getJsonLoadWiChi = async () => {
    await axios.get("/IpgoReact/IndexWorkIpgoWiChei")
      .then((res) => {setChanggowicheiopen(res.data)
        })
      };

    
    useEffect(() => {   
      getJsonLoadWorkOpen() //작업라인
      //console.log("작업라인");
    },[]);
    
    useEffect(() => {   
      getJsonLoadWorkProcess() //작업공정순서
      //console.log("공정순서");
    },[]);
    
    useEffect(() => {   
      getJsonLoadGumSaja()  //입고검사자 
      //console.log("검사자");
    },[]);
    useEffect(() => {   
      getJsonLoadWiChi()  //창고지정위치 
      //console.log("창고위치");
    },[setChanggowichei]);
    //console.log(changgowichei)
     
  let ordernoHandle= (e) => {
    e.preventDefault();
    setOrderno(e.target.value);
  }
  let changgowicheiHandle= (e) => {
    e.preventDefault();
    setChanggowichei(e.target.value);
  }
  let belmengHandle= (e) => {
    e.preventDefault();
    setBelmeng(e.target.value);
    //console.log(`계산: ${e.target.value})`);
  }
  //작업상태
  let worksangtaeHandle= (e) => {
    e.preventDefault();
    setWorksangtae(e.target.value);
  }
  let sabunHandle= (e) => {
    e.preventDefault();
    setSabun(e.target.value);
  }
  let cusitemHandle= (e) => {
    e.preventDefault();
    setCusitem(e.target.value);
  }
  let cusnameHandle= (e) => {
    e.preventDefault();
    setCusname(e.target.value);
  }
  let sanghoHandle= (e) => {
    e.preventDefault();
    setSangho(e.target.value);
  }
  let sanghocodeHandle= (e) => {
    e.preventDefault();
    setSanghocode(e.target.value);
  }
  let workcheriHandle= (e) => {
    e.preventDefault();
    setWorkcheri(e.target.value);
  }
  let chericodeHandle= (e) => {
    e.preventDefault();
    setChericode(e.target.value);
  }
  let workcherilinecodeHandle= (e) => {
    e.preventDefault();
    setWorkcherilinecode(e.target.value);
  }
  let workprocesscodeHandle= (e) => {
    e.preventDefault();
    setWorkprocesscode(e.target.value);
  }
  let gumsajaHandle= (e) => {
    e.preventDefault();
    setGumsaja(e.target.value);
  }
  let panjungHandle= (e) => {
    e.preventDefault();
    setPanjung(e.target.value);
  }
  
  let factoryHandle= (e) => {
    e.preventDefault();
    setFactory(e.target.value);
  }
  let itemmoveHandle= (e) => {
    e.preventDefault();
    setItemmove(e.target.value);
  }
  let sumdangaHandle= (e) => {
    e.preventDefault();
    setSumdanga(e.target.value);
  }
  let pimacdangaHandle= (e) => {
    e.preventDefault();
    setPimacdanga(e.target.value);
  }
  let dopodangaHandle= (e) => {
    e.preventDefault();
    setDopodanga(e.target.value);
  }
  let pricesangtaeHandle= (e) => {
    e.preventDefault();
    setPricesangtae(e.target.value);
  }
  let gressweightHandle= (e) => {
    e.preventDefault();
    setGressweight(e.target.value);
  }
  let boxeachHandle= (e) => {
    e.preventDefault();
    setBoxeach(e.target.value);
  }
  let ipgoquantityHandle= (e) => {
    e.preventDefault();
    setIpgoquantity(e.target.value);
    setIpgogumack((e.target.value) * sumdanga);
    setIpgopimacgumack((e.target.value) * pimacdanga);
    setIpgodopogumack((e.target.value) * dopodanga);
  }
  let pimacdanwieHandle= (e) => {
    e.preventDefault();
    setPimacdaewi(e.target.value);
  }
  let dopodanwieHandle= (e) => {
    e.preventDefault();
    setDopodaewi(e.target.value);
  }
  let ipgogumackHandle= (e) => {
    e.preventDefault();
    setIpgogumack(e.target.value);
  }
  let ipgopimacgumackHandle= (e) => {
    e.preventDefault();
    setIpgopimacgumack(e.target.value);
  }
  let ipgodopogumackHandle= (e) => {
    e.preventDefault();
    setIpgodopogumack(e.target.value);
  }
  let ipgoupchejunpupqtyHandle= (e) => {
    e.preventDefault();
    setIpgoupchejunpupqty(e.target.value);
  }
  let ipgoupchelotcodeHandle= (e) => {
    e.preventDefault();
    setIpgoupchelotcode(e.target.value);
  }
  //입고시업체박스
  let ipgoboxqtyHandle= (e) => {
    e.preventDefault();
    setIpgoboxqty(e.target.value);
  }
  let ipgoticketjundalHandle= (e) => {
    e.preventDefault();
    setIpgoticketjundal(e.target.value);
  }
  
  let ipgoyoochengilHandle= (e) => {
    e.preventDefault();
    setIpgoyoochengil(moment(e.target.value).format('YYYY-MM-DD HH:mm'))
  }
  
  let ipgodatetimeHandle= (e) => {
    e.preventDefault();
    setIpgodatetime(moment(e.target.value).format('YYYY-MM-DD'))
  }


  //입고버튼 전송실행
  const handleSubmit = (e) => {
    e.preventDefault();
    //console.log(worksangtae)
    if( worksangtae === "생산대기" ) {
      axios.put(`/IpgoReact/IpgoDelete?ItemAuto=${orderno}`)
       .then(response => {
         //정상적으로 처리됨
          if (response.status === 200) {
            //console.log("정상저장")
            //console.log(response.status)
            props.setDelmodal(false); //모달닫기
            props.setDbOpen(true); //자료등록시 재랜드링
            props.setEsave(true);  //저장모달열기 
          }
       }) 
       .catch(error => {
           // 오류발생시 실행
          if (error.response.status === 404) {
            //console.log("에라발생")
            //console.log(error.response)
            props.setDelmodal(false); //모달닫기
            props.setEerror(true); //에라모달열기
          }
        });
      }
    else {
      swal(`진행상태:${worksangtae}`,"생산대기 상태가 아니면 삭제할수 없습니다.", {
        button: { text: "닫기" },
        timer: 5000,
      });
      props.setDelmodal(false); //모달닫기
    }
  }

  //검사항목 모달실행
  let gumsaInsertHandle= (e) => {
    setCustomergumsaopen(true);
  }

  return (
    <div>
      <Modal open={props.delmodal}>
        <Box sx={style}>
          <div>
            <Typography
              id="modal-modal-titledlq"
              style={{
                fontFamily: "D2Coding",
                fontSize: "24px",
                color: "#ff4081",
              }}
            >
              <i className="fa-regular fa-trash-can"></i>입고삭제
            </Typography>
          </div>
          <Form onSubmit={handleSubmit}>
            <div>
              <TextField
                disabled
                variant="outlined"
                onChange={ordernoHandle}
                style={{
                  width: 100,
                  marginTop: "10px",
                  float: "center",
                  marginRight: "2px",
                }}
                //margin="normal"
                //required
                InputLabelProps={
                  orderno === "" ? { shrink: false } : { shrink: true }
                }
                id=""
                label="작지번호"
                name=""
                size="small"
                value={orderno ? orderno : ""}
              />
              <TextField
                disabled
                variant="outlined"
                onChange={belmengHandle}
                style={{
                  width: 150,
                  marginTop: "10px",
                  float: "center",
                  marginRight: "2px",
                }}
                //margin="normal"
                //require
                InputLabelProps={
                  belmeng === "" ? { shrink: false } : { shrink: true }
                }
                id="outlined-uncontrolled"
                label="별명"
                name="belmeng"
                size="small"
                value={belmeng ? belmeng : ""}
              />
              <TextField
                disabled
                variant="outlined"
                onChange={worksangtaeHandle}
                style={{
                  width: 100,
                  marginTop: "10px",
                  float: "center",
                  marginRight: "2px",
                }}
                //margin="normal"
                //requiredpanjungHandle
                InputLabelProps={
                  worksangtae === "" ? { shrink: false } : { shrink: true }
                }
                id="outlined-uncontrolled"
                label="작업상태"
                name="worksangtae"
                size="small"
                value={worksangtae ? worksangtae : ""}
              />
            </div>
            <Paper variant="outlined" square style={InspStyle}>
              <FormControl
                disabled
                required
                variant="outlined"
                style={{
                  minWidth: 150,
                  marginTop: "10px",
                  marginLeft: "6px",
                }}
                size="small"
              >
                <InputLabel id="">
                  판정
                </InputLabel>
                <CssSelect
                  value={panjung ? panjung : ""}
                  onChange={panjungHandle}
                  label="판정"
                >
                  <MenuItem value="">
                    <em>-None</em>
                  </MenuItem>
                  <MenuItem value={"합격"}>합격</MenuItem>
                  <MenuItem value={"불합격"}>불합격</MenuItem>
                </CssSelect>
              </FormControl>

              <FormControl
                disabled
                required
                variant="outlined"
                style={{
                  minWidth: 150,
                  marginTop: "8px",
                  marginLeft: "6px",
                }}
                size="small"
              >
                <InputLabel id="demo-simple-select-autowidth-label">
                  검사자
                </InputLabel>
                <CssSelect
                  value={gumsaja ? gumsaja : setGumsaja([])}
                  onChange={gumsajaHandle}
                  label="검사자"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {gumsajaopen.map((name) => (
                    <MenuItem key={name.id} value={name.inspection_gunsuja}>
                      {name.inspection_gunsuja}
                    </MenuItem>
                  ))}
                </CssSelect>
              </FormControl>
              <Button
                disabled
                variant="contained"
                size="smail"
                style={InspBtnStyle}
                onClick={gumsaInsertHandle}
              >
                검사
                <br />
                항목
              </Button>
            </Paper>
            <div></div>
            <CssTextField
              disabled
              variant="outlined"
              onChange={sabunHandle}
              style={{
                width: 150,
                marginTop: "10px",
                float: "center",
                marginRight: "2px",
              }}
              //margin="normal"
              required
              InputLabelProps={
                sabun === "" ? { shrink: false } : { shrink: true }
              }
              value={sabun ? sabun : ""}
              id=""
              label="우리품번"
              name="sabun"
              size="small"
            />
            <CssTextField
              disabled
              variant="outlined"
              onChange={cusitemHandle}
              style={{
                width: 150,
                marginTop: "10px",
                float: "center",
                marginRight: "2px",
              }}
              //margin="normal"
              //required
              InputLabelProps={
                cusitem === "" ? { shrink: false } : { shrink: true }
              }
              id=""
              label="업체품번"
              name="cusitem"
              size="small"
              value={cusitem ? cusitem : ""}
            />
            <TextField
              disabled
              variant="outlined"
              onChange={cusnameHandle}
              style={{
                width: 150,
                marginTop: "10px",
                float: "center",
                marginRight: "2px",
              }}
              //margin="normal"
              //required
              InputLabelProps={
                cusname === "" ? { shrink: false } : { shrink: true }
              }
              id="outlined-uncontrolled"
              label="품명"
              name="cusname"
              size="small"
              value={cusname ? cusname : ""}
            />
            <div>
              <div>
                <TextField
                  disabled
                  variant="outlined"
                  onChange={sanghoHandle}
                  style={{
                    width: 150,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    sangho === "" ? { shrink: false } : { shrink: true }
                  }
                  id="sangho"
                  label="업체상호"
                  name="sangho"
                  size="small"
                  value={sangho ? sangho : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={sanghocodeHandle}
                  style={{ width: 80, marginTop: "10px", float: "center" }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    sanghocode === "" ? { shrink: false } : { shrink: true }
                  }
                  id="sanghocode"
                  label="코드"
                  name="sanghocode"
                  size="small"
                  value={sanghocode ? sanghocode : ""}
                />
              </div>
              <div>
                <TextField
                  disabled
                  variant="outlined"
                  onChange={workcheriHandle}
                  style={{
                    width: 110,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    workcheri === "" ? { shrink: false } : { shrink: true }
                  }
                  id="workcheri"
                  label="시작공정"
                  name="workcheric02"
                  size="small"
                  value={workcheri ? workcheri : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={chericodeHandle}
                  style={{
                    width: 110,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    chericode === "" ? { shrink: false } : { shrink: true }
                  }
                  id="chericode"
                  label="종료코드"
                  name="chericode"
                  size="small"
                  value={chericode ? chericode : ""}
                />

                <CssFormControl
                  required
                  variant="outlined"
                  style={{
                    minWidth: 110,
                    marginTop: "10px",
                    marginRight: "2px",
                  }}
                  size="small"
                >
                  <InputLabel id="demo-simple-select-autowidth-label">
                    작업라인
                  </InputLabel>
                  <Select
                    value={
                      workcherilinecode
                        ? workcherilinecode
                        : setWorkcherilinecode([])
                    }
                    onChange={workcherilinecodeHandle}
                    autoWidth
                    label="작업라인"
                  >
                    <MenuItem value="">
                      <em>작업라인</em>
                    </MenuItem>
                    {workcherilineopne.map((name) => (
                      <MenuItem
                        key={name.id}
                        value={name.upche_price_cheri_work}
                      >
                        {name.upche_price_cheri_work}
                      </MenuItem>
                    ))}
                  </Select>
                </CssFormControl>
                <CssFormControl
                  required
                  variant="outlined"
                  style={{
                    ml: 0,
                    minWidth: 150,
                    marginTop: "10px",
                    marginRight: "2px",
                  }}
                  size="small"
                >
                  <InputLabel id="demo-simple-select-autowidth-label">
                    작업공정
                  </InputLabel>
                  <Select
                    value={workprocesscode ? workprocesscode : ""}
                    onChange={workprocesscodeHandle}
                    autoWidth
                    MenuProps={{
                      classes: { paper: selectMenu작업공정Classes.menuPaper },
                    }} //selectMenuClasses는 상단 메뉴높이이 설정함.
                    label="작업공정"
                  >
                    <MenuItem value="">
                      <em>작업공정</em>
                    </MenuItem>
                    {workprocessopen.map((name) => (
                      <MenuItem key={name.id} value={name.item_cheri}>
                        {name.item_cheri}
                      </MenuItem>
                    ))}
                  </Select>
                </CssFormControl>
                <DisabledTextField
                  disabled
                  variant="outlined"
                  onChange={factoryHandle}
                  style={{
                    width: 100,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  error
                  InputLabelProps={
                    factory === "" ? { shrink: false } : { shrink: true }
                  }
                  id="outlined-error"
                  label="세계산서발행"
                  name="factoryc02"
                  size="small"
                  value={factory ? factory : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={itemmoveHandle}
                  style={{ width: 100, marginTop: "10px", float: "center" }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    itemmove === "" ? { shrink: false } : { shrink: true }
                  }
                  id="itemmove"
                  label="입고장소"
                  name="itemmove"
                  size="small"
                  value={itemmove ? itemmove : ""}
                />
              </div>
              <div>
                <TextField
                  disabled
                  variant="outlined"
                  onChange={sumdangaHandle}
                  style={{
                    width: 80,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    sumdanga === "" ? { shrink: false } : { shrink: true }
                  }
                  id="sumdanga"
                  label="S단가"
                  name="sumdanga"
                  size="small"
                  value={sumdanga ? sumdanga : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={pimacdangaHandle}
                  style={{
                    width: 70,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    pimacdanga === "" ? { shrink: false } : { shrink: true }
                  }
                  id="pimacdanga"
                  label="피막"
                  name="pimacdanga"
                  size="small"
                  value={pimacdanga ? pimacdanga : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={dopodangaHandle}
                  style={{
                    width: 70,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    dopodanga === "" ? { shrink: false } : { shrink: true }
                  }
                  id="dopodanga"
                  label="도포"
                  name="dopodanga"
                  size="small"
                  value={dopodanga ? dopodanga : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={pricesangtaeHandle}
                  style={{
                    width: 100,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    pricesangtae === "" ? { shrink: false } : { shrink: true }
                  }
                  id="pricesangtae"
                  label="단가상태"
                  name="pricesangtae"
                  size="small"
                  value={pricesangtae ? pricesangtae : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={gressweightHandle}
                  style={{
                    width: 100,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    gressweight === "" ? { shrink: false } : { shrink: true }
                  }
                  id="gressweight"
                  label="개당중량"
                  name="gressweight"
                  size="small"
                  value={gressweight ? gressweight : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={boxeachHandle}
                  style={{
                    width: 100,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  //margin="normal"
                  //required
                  InputLabelProps={
                    boxeach === "" ? { shrink: false } : { shrink: true }
                  }
                  id="boxeach"
                  label="당량"
                  name="boxeach"
                  size="small"
                  value={boxeach ? boxeach : ""}
                />
              </div>
              <div>
                <TextField
                  disabled
                  variant="outlined"
                  onChange={pimacdanwieHandle}
                  style={{
                    width: 70,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  InputLabelProps={
                    pimacdaewi === "" ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="pimacdaewi"
                  label="피단위"
                  name="pimacdaewi"
                  size="small"
                  value={pimacdaewi ? pimacdaewi : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={dopodanwieHandle}
                  style={{
                    width: 70,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  InputLabelProps={
                    dopodaewi === "" ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="dopodaewi"
                  label="도단위"
                  name="dopodaewi"
                  size="small"
                  value={dopodaewi ? dopodaewi : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={ipgogumackHandle}
                  required
                  style={{
                    width: 120,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  InputLabelProps={
                    ipgogumack === 0 ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="ipgogumack"
                  label="입고금액"
                  name="ipgogumack"
                  size="small"
                  value={ipgogumack ? ipgogumack : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={ipgopimacgumackHandle}
                  required
                  style={{
                    width: 100,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  InputLabelProps={
                    ipgopimacgumack === 0 ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="ipgopimacgumack"
                  label="피막금액"
                  name="ipgopimacgumack"
                  size="small"
                  value={ipgopimacgumack ? ipgopimacgumack : ""}
                />
                <TextField
                  disabled
                  variant="outlined"
                  onChange={ipgodopogumackHandle}
                  required
                  style={{ width: 100, marginTop: "10px", float: "center" }}
                  InputLabelProps={
                    ipgodopogumack === 0 ? { shrink: false } : { shrink: true }
                  }
                  type="text"
                  id="ipgodopogumack"
                  label="도포금액"
                  name="ipgodopogumack"
                  size="small"
                  value={ipgodopogumack ? ipgodopogumack : ""}
                />
              </div>
              <div>
                <CssTextField
                  variant="outlined"
                  onChange={ipgoquantityHandle} //onClick={gumsajahangmugHandle}
                  inputProps={{ inputMode: "numeric", pattern: "([^0-9]*)" }}
                  primary={"숫자만 입력됩니다."}
                  //inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                  style={{
                    width: 150,
                    marginTop: "10px",
                    marginRight: "2px",
                    float: "center",
                  }}
                  //margin="normal"
                  required
                  //InputLabelProps={ipgoquantity === true ? {ipgoquantity: false} : {ipgoquantity: true}}
                  type="number"
                  id="c05"
                  label="수정수량"
                  name="ipgoquantity"
                  size="small"
                  value={ipgoquantity ? ipgoquantity : ""}
                />
              </div>

              <div>
                <CssTextField
                  onChange={ipgoupchejunpupqtyHandle}
                  variant="outlined"
                  style={{
                    width: 150,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  required
                  //InputLabelProps={ipgoupchejunpupqty === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoupchejunpupqty"
                  label="업체전표수량"
                  name="ipgoupchejunpupqty"
                  size="small"
                  value={ipgoupchejunpupqty ? ipgoupchejunpupqty : ""}
                />
                <CssTextField
                  onChange={ipgoupchelotcodeHandle}
                  variant="outlined"
                  style={{
                    width: 150,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  required
                  //InputLabelProps={ipgoupchelotcode === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoupchelotcode"
                  label="업체로트No"
                  name="ipgoupchelotcode"
                  size="small"
                  value={ipgoupchelotcode ? ipgoupchelotcode : ""}
                />
                <CssTextField
                  onChange={ipgoboxqtyHandle}
                  variant="outlined"
                  style={{
                    width: 150,
                    marginTop: "10px",
                    float: "center",
                    marginRight: "2px",
                  }}
                  required
                  //InputLabelProps={ipgoticketjundal === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoboxqty"
                  label="업체입고[박스]"
                  name="ipgoboxqty"
                  size="small"
                  value={ipgoboxqty ? ipgoboxqty : ""}
                />
                <CssFormControl
                  required
                  variant="outlined"
                  style={{
                    minWidth: 110,
                    marginTop: "10px",
                    marginRight: "2px",
                    maxMenuHeight: "10px",
                  }}
                  size="small"
                >
                  <InputLabel id="">보관위치</InputLabel>
                  <Select
                    value={changgowichei ? changgowichei : ""}
                    onChange={changgowicheiHandle}
                    MenuProps={{
                      classes: { paper: selectMenu보관위치Classes.menuPaper },
                    }} //selectMenuClasses는 상단 메뉴높이이 설정함.
                    //renderInput={(params) => <TextField {...params} variant="standard" label="보관위치" />}
                    label="보관위치"
                  >
                    {/* //볼러온창고값 보여주기 */}
                    <MenuItem value={changgowichei}>{changgowichei}</MenuItem>
                    {/* <MenuItem value=''><em>-지정위치-</em></MenuItem> */}
                    {changgowicheiopen.map((name, index) => (
                      <MenuItem key={index} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </CssFormControl>
              </div>
              <div>
                <CssTextField
                  onChange={ipgoticketjundalHandle}
                  variant="outlined"
                  style={{ width: 350, marginTop: "10px", float: "center" }}
                  //InputLabelProps={ipgoticketjundal === '' ? {shrink: false} : {shrink: true}}
                  type="text"
                  id="ipgoticketjundal"
                  label="작업전달사항"
                  name="ipgoticketjundal"
                  size="small"
                  value={ipgoticketjundal ? ipgoticketjundal : ""}
                />
              </div>
              <div>
              <CssTextField style={{marginRight:2}}
                  id="datetime-local"
                  size="small"
                  label="작업완료요구일"
                  variant="outlined"
                  type="datetime-local"
                  format='YYYY-MM-DD HH:mm'
                  value={ipgoyoochengil ? ipgoyoochengil : '' }
                  className={classes.textField}
                  onChange={ipgoyoochengilHandle}
                  InputLabelProps={{
                    shrink: true,
                  }}
              />
                  <DisabledTextField 
                  disabled
                  id="datetime-local"
                  size="small"
                  label="등록일자"
                  variant="outlined"
                  type="datetime"
                  format='YYYY-MM-DD HH:mm'
                  value={ipgodatetime ? ipgodatetime : setIpgodatetime(moment().format('YYYY-MM-DD HH:mm')) }
                  className={classes.textField}
                  onChange={ipgodatetimeHandle}
                  InputLabelProps={{
                    shrink: true,
                  }}
              />
              </div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <Button //onClick={buttonClickHeandle}
                type="submit"
                startIcon={<SaveIcon />}
                variant="contained"
                style={{
                  background: '#5e35b1',
                  color:'white',
                  height: "37px",
                  width: 100,
                  marginRight: "2px",
                  float: "center",
                }}
              >
                삭제
              </Button>

              <Button
                onClick={() => {
                  props.setDelmodal(false);
                }}
                variant="contained"
                style={{
                  background: '#3949ab',
                  color:'white',
                  height: "37px",
                  width: 100,
                  marginTop: "2px",
                  float: "center",
                }}
              >
                <i className="fa-solid fa-xmark" style={{marginRight: 10, fontSize: 20 }}></i>닫기
              </Button>
            </div>
          </Form>
        </Box>
      </Modal>
    </div>
  );
}

export default IpgoDelete
